import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const ROWS = [
    { eu: "EU 36-37", us: "US W6-7", cm: "23,0 cm" },
    { eu: "EU 38-39", us: "US M6-7", cm: "24,5 cm" },
    { eu: "EU 40-41", us: "US M7-8", cm: "25,8 cm" },
    { eu: "EU 42-43", us: "US M8-9", cm: "27,0 cm" },
    { eu: "EU 44-45", us: "US M9-10", cm: "28,5 cm" },
    { eu: "EU 46-47", us: "US M10-11", cm: "29,8 cm" },
];

export default function SizeGuide() {
    return (
        <section id="sizing" className="py-24 sm:py-28">
            <div className="max-w-3xl mx-auto px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                >
                    <p className="text-xs font-mono-brand uppercase tracking-[0.3em] text-spidey-neon">
                        Guide des tailles
                    </p>
                    <h2 className="mt-3 font-display uppercase text-3xl sm:text-4xl text-white tracking-tight mb-8">
                        Trouve ta taille idéale.
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                >
                    <Accordion type="single" collapsible className="bg-spidey-card border border-zinc-800/80 rounded-2xl px-6">
                        <AccordionItem value="tailles" className="border-zinc-800/80">
                            <AccordionTrigger
                                className="text-white font-mono-brand uppercase tracking-[0.15em] text-sm py-6 hover:text-spidey-neon hover:no-underline"
                                data-testid="size-guide-trigger"
                            >
                                Correspondance EU / US / CM
                            </AccordionTrigger>
                            <AccordionContent className="pb-8">
                                <table className="w-full text-sm" data-testid="size-guide-table">
                                    <thead>
                                        <tr className="text-left font-mono-brand text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                                            <th className="py-3 font-normal">Europe</th>
                                            <th className="py-3 font-normal">US</th>
                                            <th className="py-3 font-normal">Longueur</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-zinc-300">
                                        {ROWS.map((r) => (
                                            <tr key={r.eu} className="border-t border-zinc-800/60">
                                                <td className="py-3 font-mono-brand">{r.eu}</td>
                                                <td className="py-3">{r.us}</td>
                                                <td className="py-3">{r.cm}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <p className="mt-5 text-xs text-zinc-500 leading-relaxed">
                                    Astuce : prends ta taille Crocs habituelle. En cas
                                    d'hésitation entre deux tailles, choisis la plus petite —
                                    la coupe Croslite™ ajuste au pied.
                                </p>
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
}
